import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';

/** Bloquea rutas de desarrollo (previews, etc.) fuera de builds no-producción. */
export const devOnlyGuard: CanActivateFn = () => {
  if (!environment.production) return true;

  const router = inject(Router);
  void router.navigate(['/']);
  return false;
};
